<script setup>
import { toRefs, toRef } from 'vue'
import { useErrorMessage } from '@/studentsite/common/useErrorMessage'
import { setup } from './useUniversitySelection'

/**
 * @import { PropType } from 'vue'
 * @import { Emits } from './emitTypes'
 * @import { University } from '../Suggest/useUniversityList'
 * @import { ComponentProps } from '../../../propTypes'
 */

/** @type {Emits<Array<University>>} */
const emits = defineEmits(['inputChange', 'selectionChange', 'textChange'])

const props = defineProps({
  default: {
    type: String,
    default: '',
  },
  universityList: {
    /** @type {PropType<Array<University>>} */
    type: Array,
    required: true,
  },
  inputErrors: {
    /** @type {PropType<ComponentProps["inputErrors"]>} */
    type: Object,
    required: true,
  },
  validationErrors: {
    /** @type {PropType<string[]>} */
    type: Object,
    required: true,
  },
})
const { has: errorHas } = useErrorMessage(toRef(() => props.inputErrors).value)
const reactiveProps = toRefs(props)

const {
  value,
  universityList: itemList,
  openSuggestions,
  onClickOption,
  onFocusEvent,
  onInput,
  onChange,
  clearValue,
} = setup(props.default, reactiveProps.universityList, emits)

defineExpose({ clearValue })
</script>

<template>
  <input
    :value="value"
    name="university_name"
    type="text"
    placeholder="学校名を入力"
    class="form--line form--w100 js_suggestOpen js_dataInput"
    :class="{ md_error: errorHas('university_cd') || errorHas('university_name') || validationErrors.length }"
    autocomplete="off"
    @focus="onFocusEvent(true)"
    @blur="onFocusEvent(false)"
    @input="onInput"
    @change="onChange"
  />
  <ul
    v-show="openSuggestions"
    class="md_list md_list--suggest"
  >
    <li
      v-for="item in itemList"
      :key="`university_suggestion_${item.cd}`"
      class="row"
      @mousedown="onClickOption(item)"
    >
      <button
        type="button"
        class="list js_suggestInput js_suggestX"
      >
        <div class="txtCell">
          <div class="txtSet">
            <div
              class="main"
              v-text="item.text"
            />
          </div>
        </div>
      </button>
    </li>
  </ul>
</template>
